import script from "./CustomerDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerDashboard.vue?vue&type=script&setup=true&lang=js"

import "./CustomerDashboard.vue?vue&type=style&index=0&id=a2c2f892&scoped=true&lang=css"

import exportComponent from "E:\\dipto_projects\\parcel\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2c2f892"]])

export default __exports__